var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustSaturateOff100X100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    stroke: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 51.8384C30 63.5351 38.95 73 50 73C61.05 73 70 63.5351 70 51.8384C65 47 55.5 48.6768 50 51.8384C44.5 55 34.5 57 30 51.8384Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51.8384C30 46.0035 32.25 40.7064 35.875 36.8613L48.25 23.7663C48.7375 23.2554 49.3688 23 50 23C50.6312 23 51.2625 23.2554 51.75 23.7663L64.125 36.8613C66.9361 39.8431 68.9204 43.6981 69.6697 48C69.8866 49.2455 70 50.5284 70 51.8384M30 51.8384C30 63.5351 38.95 73 50 73C61.05 73 70 63.5351 70 51.8384M30 51.8384C34.5 57 44.5 55 50 51.8384C55.5 48.6768 65 47 70 51.8384",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustSaturateOff100X100);
export default __webpack_public_path__ + "static/media/adjust_saturate_off_100x100.8dde89bb0fde0adc0f1eb364855114eb.svg";
export { ForwardRef as ReactComponent };